import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
// import Maps from "views/examples/Maps.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
// import Tables from "views/examples/Tables.js";
// import Icons from "views/examples/Icons.js";
import Tenant from "views/examples/Tenant";
import FurnitureCompany from "views/examples/FurnitureCompany";
import CleaningCompany from "views/examples/CleaningCompany";
import HouseOwner from "views/examples/HouseOwner";
import { UserProfile } from "components/UserProfile/UserProfile";
import OrderHistory from "components/UserProfile/OrderHistory";
import FurniturePackage from "components/PackageInfomation/FurniturePackage";
import CleaningPackage from "components/PackageInfomation/CleaningPackage";
import { FurnitureDetail } from "components/PackageInfomation/FurnitureDetail";
import HouseList from "components/Houses/HouseList";
import Report from "views/examples/Report";
import { Navigate } from "react-router-dom";
import { encryptDecryptData } from "utils/helperFunction";
import BookingCharges from "views/examples/BookingChargesList";
import SecurityInsurance from "views/examples/SecurityInsurance";
import KycManagement from "views/examples/KycManagement";
import PaymentDistributions from "views/examples/PaymentDistributions";
import TrustedPartners from "views/examples/TrustedPartners";

const checkAuth = () => {
  const storedData = encryptDecryptData.decrypt(localStorage.getItem("user"));
  // Check if user is logged in by checking if a certain key exists in localStorage
  return storedData?.id ? true : false;
};
var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <Index />,
    layout: "/admin",
    requiresAuth: true,
  },
  {
    path: "/tenant",
    name: "Tenant List",
    icon: "ni ni-pin-3 text-orange",
    component: <Tenant />,
    layout: "/admin",
    requiresAuth: true,
  },
  // {
  //   path: "/furniture-company-list",
  //   name: "Furniture  Company List",
  //   icon: "ni ni-planet text-blue",
  //   component: <FurnitureCompany />,
  //   layout: "/admin",
  //   requiresAuth: true,
  // },
  {
    path: "/cleaning-company-list",
    name: "Cleaning Company List",
    icon: "ni ni-pin-3 text-orange",
    component: <CleaningCompany />,
    layout: "/admin",
  },
  {
    path: "/cleaning-company/package",
    component: <CleaningPackage />,
    layout: "/pages",
    requiresAuth: true,
  },
  {
    path: "/home_owner",
    name: "Home Owner List",
    icon: "ni ni-single-02 text-yellow",
    component: <HouseOwner />,
    layout: "/admin",
    requiresAuth: true,
  },
  {
    path: "/booking_charges",
    name: "Booking Charges",
    icon: "ni ni-single-02 text-yellow",
    component: <BookingCharges />,
    layout: "/admin",
    requiresAuth: true,
  },
  {
    path: "/sercurity-insurance-fee",
    name: "Sercurity Insurance",
    icon: "ni ni-single-02 text-yellow",
    component: <SecurityInsurance />,
    layout: "/admin",
    requiresAuth: true,
  },
  {
    path: "/report",
    name: "Report",
    icon: "ni ni-pin-3 text-orange",
    component: <Report />,
    layout: "/admin",
    requiresAuth: true,
  },
  {
    path: "/kyc-management",
    name: "KYC Management",
    icon: "ni ni-check-bold text-info",
    component: <KycManagement />,
    layout: "/admin",
    requiresAuth: true,
  },
  {
    path: "/distributions",
    name: "Disbursements",
    icon: "ni ni-credit-card text-success",
    component: <PaymentDistributions />,
    layout: "/admin",
    requiresAuth: true,
  },
  {
    path: "/trusted-partners",
    name: "Trusted Partners",
    icon: "ni ni-briefcase-24 text-primary",
    component: <TrustedPartners />,
    layout: "/admin",
    requiresAuth: true,
  },

  {
    path: "/:role/:userId",
    component: <UserProfile />,
    layout: "/pages",
    requiresAuth: true,
  },
  {
    path: "/user-profile",
    name: " Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    requiresAuth: true,
  },
  {
    path: "/order",
    component: <OrderHistory />,
    layout: "/pages",
    requiresAuth: true,
  },
  {
    path: "/furniture_company/package",
    component: <FurniturePackage />,
    layout: "/pages",
    requiresAuth: true,
  },
  {
    path: "/furniture_company/furniture",
    component: <FurnitureDetail />,
    layout: "/pages",
    requiresAuth: true,
  },
  {
    path: "/home_owner/houses",
    component: <HouseList />,
    layout: "/pages",
    requiresAuth: true,
  },

  // {
  //   path: "/register",
  //   name: "Register",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: <Register />,
  //   layout: "/auth",
  // },
  {
    path: "/Login",
    name: "Login",
    icon: "ni ni-circle-08 text-pink",
    component: <Login />,
    layout: "/auth",
    requiresAuth: false,
  },
];
const authenticatedRoutes = routes.map((route) => {
  // If the route requires authentication but the user is not authenticated, redirect to Login
  if (route.requiresAuth && !checkAuth()) {
    return {
      ...route,
      component: <Navigate to="/auth/login" replace />,
    };
  }
  return route;
});

export default authenticatedRoutes;

// export default routes;
